/** Propiedad GA4 de MapaGol. */
export const GA_ID = "G-DJGSHB1KM9";

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

let loaded = false;

/**
 * Carga Google Analytics (gtag.js). Solo se llama cuando el jugador ha aceptado
 * las cookies: antes de decidir no se hace ninguna petición a Google. Deja el
 * consentimiento de Consent Mode en "granted" para la única categoría que usamos
 * (analítica); publicidad queda denegada de forma explícita.
 */
export function loadAnalytics(): void {
  if (loaded || typeof window === "undefined") return;
  loaded = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer ?? [];
  window.gtag = (...args: unknown[]) => {
    window.dataLayer!.push(args);
  };
  window.gtag("js", new Date());
  window.gtag("consent", "update", {
    analytics_storage: "granted",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });
  window.gtag("config", GA_ID);
}

/** Revoca la analítica si el jugador retira su consentimiento. */
export function revokeAnalytics(): void {
  if (!loaded) return;
  window.gtag?.("consent", "update", { analytics_storage: "denied" });
}
